import { getUuid } from 'shared/utils/getUuid/getUuid';

type SessionMemoryStore = {
  clear: () => void;
};

const sessionMemoryStores = new Set<SessionMemoryStore>();

export const createSessionMemoryStore = <Value>() => {
  const values = new Map<string, Value>();
  sessionMemoryStores.add({
    clear: () => values.clear(),
  });

  return {
    store: (value: Value) => {
      const id = getUuid();
      values.set(id, value);
      return id;
    },
    get: (id?: string) => (id ? values.get(id) : undefined),
    remove: (id?: string) => {
      if (id) {
        values.delete(id);
      }
    },
  };
};

export const clearSessionMemoryStores = () => {
  sessionMemoryStores.forEach((store) => store.clear());
};
